module.exports = __webpack_public_path__ + "images/emoji/anger.1a8fc881f277d6b5c7a7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/anger.png
// module id = ii69
// module chunks = 1